module.exports = __webpack_public_path__ + "assets/img/gameTip.435316bf.png";